import { render, staticRenderFns } from "./RefrigeratedGoods.vue?vue&type=template&id=4f2a82b4&scoped=true&"
import script from "./RefrigeratedGoods.vue?vue&type=script&lang=js&"
export * from "./RefrigeratedGoods.vue?vue&type=script&lang=js&"
import style0 from "./RefrigeratedGoods.vue?vue&type=style&index=0&id=4f2a82b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a82b4",
  null
  
)

export default component.exports